module.exports = __webpack_public_path__ + "img/stanford.84198387.svg";